<template>
  <div class="invite-content">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="invite-img-box">
          <div class="invite-img" v-for="(item,index) in imgList" :key="index">
            <div ref="imageWrapper" class="myDiv">
              <van-image :src="item.url" alt @click="checkImg(item,index)">
                <div class="pop-style" v-show="isShowUser">
                  <div class="item-center">
                    <div class="user-info">
                      <div>{{userInfo.realName}}</div>
                      <div>{{userInfo.phone}}</div>
                    </div>
                    <div class="qr-div">
                      <qrcode :staffId="id" :avatarName="userInfo.avatarName"></qrcode>
                    </div>
                  </div>
                </div>
              </van-image>
            </div>
            <van-popup v-model="show" @close="closePop" :overlay="false" closeable>
              <div class="pop-title">长按图片保存</div>
              <img :src="showImg" alt class="i-show-img" />
            </van-popup>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import qrcode from './qrcode.vue'
import URL from "@/api/api";
import { Dialog, Toast } from "vant";
import html2canvas from 'html2canvas'
export default {
  components: { qrcode },
  data() {
    return {
      imgList: [],
      showImg: '',
      show: false,
      userid: '',
      id: null,
      userInfo: {},
      width: `${document.documentElement.clientWidth}px`,
      height: `${document.documentElement.clientWidth * 1.777}px`,
      isShowUser: false,
      page:1,//当前页
      size:10,//每页数据10条
      loading: false,//加载中
      finished: false,//是否已加载完成
      refreshing: false,//下拉刷新
    }
  },
  mounted() {
    let that = this
    that.getstaff()
    that.getInvite()
  },
  methods: {
    onRefresh() {
      let that = this
      that.finished = false;
      that.page = 1
      that.loading = true;
      that.getInvite();
    },
    onLoad() {
      this.getInvite();
    },
    getInvite(){
      let that = this 
      let data={
        page:this.page,
        size:this.size,
        companyCode: 'ZFKJ',
        picType: 1
      }
      that.$fetchGet(URL.posterImage.url,data).then(res=>{
        that.refreshing = false;
        that.loading = false;
        that.total = res.data.data.total;
        let list = res.data.data.records;
        if (list == null || list.length === 0) {
          // 加载结束
          that.finished = true;
          that.newDataList = []
          return;
        }
        // 将新数据与老数据进行合并
        if (that.page > 1) {
          that.imgList = [...that.imgList, ...list]
        } else {
          that.imgList = list
        }
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.imgList.length >= that.total) {
          that.finished = true;
        }
        //说明可能还有下一页
        if (that.imgList.length < that.total) {
          that.page++;
        }
      })
    },
    checkImg(item, index) {
      let that = this
      that.show = true
      that.isShowUser = true
      that.showImg = item.img
      Toast.loading({
        message: '加载中...',
        forbidClick: true, // 禁止背景点击
        duration: 0 // 持续展示
      })
      var opts = {
        useCORS: true, // 【重要】开启跨域配置
        scrollY: 0, // 纵向偏移量 写死0 可以避免滚动造成偶尔偏移的现象
        scrollX: 0,
        height: that.$refs.imageWrapper[index].offsetHeight - 8,
        width: that.$refs.imageWrapper[index].offsetWidth,
        scale: 8,
        dpi: window.devicePixelRatio * 2,
        // backgroundColor: 'null',
      };
      setTimeout(() => {
        html2canvas(that.$refs.imageWrapper[index], opts).then(canvas => {
          that.showImg = canvas.toDataURL("image/jpeg");
          Toast.clear()
        });
      }, 500)
    },

    getstaff() {
      this.userid = localStorage.getItem("userid")
      this.$fetchGet(URL.getStaffsCard.url, { userId: this.userid }).then((res) => {
        if (res.data.code == 20000) {
          this.id = res.data.data.id
          this.userInfo = res.data.data
        }
      })
    },
    closePop() {
      this.isShowUser = false
    }
  },
}

</script>

<style lang="less" scoped>
.invite-content {
  height: calc(100vh - 20px);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 10px;
  overflow: scroll;
  .van-popup {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
  }
  .i-show-img {
    width: 85%;
    display: block;
    margin: auto;
  }
  .invite-img-box{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .invite-img {
    width: calc(50% - 0.1rem);
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .myDiv {
    width: 100%;
  }
  .pop-title {
    height: 65px;
    font-size: 0.3rem;
    text-align: center;
    line-height: 60px;
  }
  .van-image {
   /deep/ .pop-style {
      height: 1.2rem;
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      bottom: 0.1rem;
      width: 95%;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 5px;
      .item-center {
        height: 1.1rem;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        justify-items: center;
        .user-info {
          color: #fff;
          font-size: 0.25rem;
          line-height: 1.2;
        }
        .qr-div{
          width: 35px;
          height: 35px;
        }
      }
    }
  }
}
</style>